import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { ShieldCheck, RefreshCw, ArrowLeft } from "lucide-react";

const MFAChallengePage = () => {
  const { completeMFA, user } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const completed = useRef(false);

  useEffect(() => {
    const tok = sessionStorage.getItem("mfa_token");
    if (!tok) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    if (user && completed.current) {
      if (user.role === "contribuyente") navigate("/portal/dashboard", { replace: true });
      else navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (code.length !== 6) return;
    setLoading(true);
    completed.current = true;
    const res = await completeMFA(code);
    if (!res.success) completed.current = false;
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-900 via-blue-800 to-slate-900 p-4">
      <Card className="w-full max-w-md" data-testid="mfa-challenge-card">
        <CardHeader className="space-y-3 text-center">
          <div className="mx-auto w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center">
            <ShieldCheck className="w-7 h-7 text-emerald-600" />
          </div>
          <CardTitle>Verificación en dos pasos</CardTitle>
          <p className="text-sm text-slate-500">
            Ingrese el código de 6 dígitos generado por su aplicación autenticadora
            (Google Authenticator, Authy, etc.)
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="text"
              inputMode="numeric"
              pattern="[0-9]{6}"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
              placeholder="123456"
              className="text-center text-2xl tracking-[0.5em] font-mono h-14"
              autoFocus
              data-testid="mfa-code-input"
            />
            <Button
              type="submit"
              disabled={loading || code.length !== 6}
              className="w-full bg-emerald-600 hover:bg-emerald-700"
              data-testid="mfa-verify-btn"
            >
              {loading ? (
                <>
                  <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> Verificando...
                </>
              ) : (
                "Verificar"
              )}
            </Button>
            <Button
              type="button"
              variant="ghost"
              className="w-full text-slate-500"
              onClick={() => {
                sessionStorage.removeItem("mfa_token");
                navigate("/login", { replace: true });
              }}
              data-testid="mfa-cancel-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" /> Volver al inicio
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default MFAChallengePage;
